const chunkArray = (array, chunkSize) =>
  array.reduce(
    (a, b, i, g) =>
      !(i % chunkSize) ? a.concat([g.slice(i, i + chunkSize)]) : a,
    []
  );

export default chunkArray;
